import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import PaidIcon from '@mui/icons-material/Paid';
import StarsIcon from '@mui/icons-material/Stars';
import { useTranslation } from 'react-i18next';

type props = {
  type: 'Performance' | 'Marketing' | 'Transactions';
};
const ExploreSectionHeading: React.FC<props> = ({ type }) => {
  const { t: tNavMenu } = useTranslation('navMenu');
  const { t: tExplore } = useTranslation('explore');

  const theme = useTheme();
  const performance = (
    <StarsIcon
      data-testid="performance-icon"
      sx={{
        color: '#FFD700',
        fontSize: '2.25em',
      }}
    />
  );
  const transaction = (
    <PaidIcon
      data-testid="transaction-icon"
      sx={{
        color: '#4CAF50',
        fontSize: '2.25em',
      }}
    />
  );
  const marketing = (
    <AutoAwesomeIcon
      data-testid="marketing-icon"
      sx={{
        color: '#F44336',
        fontSize: '2.25em',
      }}
    />
  );
  return (
    <Box
      data-testid="explore-heading"
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        textAlign: 'center',
        justifyContent: 'center',
        gap: 1,
      }}
    >
      <Box
        data-testid="explore-heading-content"
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        {type === 'Performance' && performance}
        {type === 'Transactions' && transaction}
        {type === 'Marketing' && marketing}
        <Typography
          data-testid="explore-heading-title"
          sx={{
            color: theme.palette.primary.main,
            fontSize: '2.25em',
            fontWeight: '500',
            fontVariant: 'h4',
            fontFamily: 'Roboto, serif',
            letterSpacing: '0.25px',
          }}
        >
          {tNavMenu(`menu.${type.toLowerCase()}`)}
        </Typography>
      </Box>

      <Typography
        variant="subtitle1"
        color="textSecondary"
        gutterBottom
        data-testid="explore-heading-subtitle"
        sx={{
          fontVariant: 'h1',
          color: theme.palette.primary.main,
          fontWeight: 'regular',
          fontSize: '20px',
          lineHeight: '26.68px',
        }}
      >
        {tExplore('performanceSubHeading')}
      </Typography>
    </Box>
  );
};

export default ExploreSectionHeading;
